import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { factSheetTypes } from '../../../../../common/order/factSheetReport/constants'
import { TableSelect } from '../../../../../common/order/factSheetReport/factSheetContent/TableSelect'
import { getDataAvailability } from '../../../../../common/order/factSheetReport/store/thunk'
import { PopupAction } from '../../../../../common/popup/PopupAction'
import { selectCompanyInfo } from '../../../../../companyAnalysis/common/header/companyInfo/store/slice'
import EventEmitter, {
  SHOW_SETTING_FS,
} from '../../../../../helpers/EventEmitter'
import { COMPONENTS } from '../../../../../routers/constants'
import classes from '../index.module.scss'
import { selectSettingFs } from '../store/slice'
import CurrencyUnit from './CurrencyUnit'

export const PopupSettingFs = () => {
  const dispatch = useDispatch()

  const companyInfo = useSelector(selectCompanyInfo)
  const settingFs = useSelector(selectSettingFs)

  const [isShow, setIsShow] = useState(false)

  useEffect(() => {
    EventEmitter.subscribe(SHOW_SETTING_FS, setIsShow)
    return () => EventEmitter.unsubscribe(SHOW_SETTING_FS, setIsShow)
  }, [])

  useEffect(() => {
    if (isShow) {
      dispatch(
        getDataAvailability({
          organizationId: companyInfo.organizationId,
          ...settingFs,
        }),
      )
    }
  }, [isShow])

  const handleClose = () => {
    setIsShow(false)
  }

  const goToFs = () => {
    window.open(
      COMPONENTS.companyAnalysis.components.financial.components
        .financialStatements.route +
        '?organizationId=' +
        companyInfo.organizationId,
    )
  }

  return (
    <PopupAction
      appendStyle={{
        backgroundColor: '#F3F3F3',
        borderRadius: 4,
        width: 930,
        padding: 20,
      }}
      isShow={isShow}
      title="dynamicReport.SETTING_FS_TITLE"
      handleClose={handleClose}
    >
      <div className={classes.headerSettingFs}>
        <div>
          <Translate value="dynamicReport.SETTING_FS_NOTE_1" />
          <Element
            className="cursorPointer"
            elementName="span"
            style={{ color: '#2C73E8' }}
            onClick={goToFs}
          >
            <Translate value="dynamicReport.SETTING_FS_NOTE_2" />
          </Element>
          <Translate value="dynamicReport.SETTING_FS_NOTE_3" />
        </div>
        <div>
          <Translate value="dynamicReport.SETTING_FS_NOTE_4" />
        </div>
      </div>
      <Element
        className={classes.contentSettingFs}
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <TableSelect type={factSheetTypes.SETTING_DYNAMIC_REPORT} />
      </Element>
      <CurrencyUnit isShow={isShow} handleClose={handleClose} />
    </PopupAction>
  )
}
